import { render, staticRenderFns } from "./video-player-youtube.vue?vue&type=template&id=dc5f8cea&lang=pug"
import script from "./video-player-youtube.vue?vue&type=script&lang=js"
export * from "./video-player-youtube.vue?vue&type=script&lang=js"
import style0 from "./video-player-youtube.vue?vue&type=style&index=0&id=dc5f8cea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports